import { render } from "./MoneyComponent.vue?vue&type=template&id=7312985c"
import script from "./MoneyComponent.vue?vue&type=script&lang=js"
export * from "./MoneyComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__